import React, { Component } from 'react';
import {Row} from 'react-bootstrap';
import { Route, withRouter, Switch } from 'react-router-dom';
import '../../../styles/variables.css';
import './DashboardAdmin.css';
import Sidenav from './components/Sidenav';
import MainContent from './Main/MainContent';
import AddVacancies from './AddVacancy/AddVacancies';
import DeleteVacancy from './DeleteVacancy/DeleteVacancy';
import AddCompany from './AddCompany/AddCompany'

class DashboardAdmin extends Component {
    render(){
        return(
            <div className="container">
                <Row>
                    <Sidenav {...this.props}/>
                    <div className="main">
                        <Switch>
                            <Route exact path={`${this.props.match.url}/vacancies`} component={AddVacancies}/>
                            <Route exact path={`${this.props.match.url}/delete`} component={DeleteVacancy}/>
                            <Route exact path={`${this.props.match.url}/new-company`} component={AddCompany}/>
                        </Switch>
                    </div>
                </Row>
            </div>
        )
    }
}
export default withRouter(DashboardAdmin);